module.exports = __webpack_public_path__ + "static/media/QRcodeVersar-appleStore.f913a71d.svg";